export default __webpack_public_path__ + "static/media/x-mark.aebc3f49.svg";